module.exports = __webpack_public_path__ + "assets/img/delivery.e9da12d5.svg";